import React from 'react';
import Icon from '../../Icon';

const Dropdown = ({ label, value, options, onChange }) => {
  return (
    <div className="optionGroup">
      {label && <label>{label}</label>}
      <div className="selectWrapper">
        <select value={value} onChange={(e) => onChange(e.target.value)}>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <Icon icon={'caret-down-fill'} className="icon caret-down-fill" />
      </div>
    </div>
  );
};

export default Dropdown;
